// src/analytics.ts

const GA_MEASUREMENT_ID = 'G-B5YYFCQNBC'; // your GA measurement ID

// Make TS happy about window.gtag
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

// Track a page view (for SPA route changes)
export function trackPageView(path: string) {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
  });
}

// Track a custom event (button clicks, etc.)
export function trackEvent(eventName: string, params: Record<string, any> = {}) {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('event', eventName, params);
}
